import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { BienesCulturalesService } from './bienes-culturales.service';

@Injectable({ providedIn: 'root' })
export class BienesCulturalesResolver implements Resolve<any> {
    constructor(private bienesService: BienesCulturalesService){
    
        }
    
    resolve(route: ActivatedRouteSnapshot): Observable<any>{
        const seccion_uuid = route.paramMap.get('seccion_uuid');
        
        if (seccion_uuid) {
            const params={inicio:0, max:10, seccion:seccion_uuid}
            this.bienesService.bienesCulturealesFilterParmas = params
            return forkJoin([
                    this.bienesService.getFichaRegistro(params)
                ]);
        }
        else {
            const params={inicio:0, max:10,}
             this.bienesService.bienesCulturealesFilterParmas = params
            return forkJoin([
                    this.bienesService.getFichaRegistro(params)
                ]);
        }
        
    }
}